import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3045bae4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Your Details\n          ")
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-red-700 text-sm" }, "\n          This person will receive the updated letters, contract and / or terms\n          and condtions for the employee.\n        ", -1));
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = {
    key: 0,
    class: "col-span-6 mb-4"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Hiring Manager details: *", -1));
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = {
    key: 1,
    class: "col-span-6 p-4 border border-gray-300 rounded-md"
};
const _hoisted_10 = {
    key: 0,
    class: "flex w-full justify-end"
};
const _hoisted_11 = { class: "col-span-6" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "name",
    class: "block text-sm font-medium text-gray-700"
}, "Name *", -1));
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "col-span-6 mt-4" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "email",
    class: "block text-sm font-medium text-gray-700"
}, "Email address: *", -1));
const _hoisted_16 = ["value"];
const _hoisted_17 = { class: "col-span-6" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "phone",
    class: "block text-sm font-medium text-gray-700"
}, "Telephone number *", -1));
const _hoisted_19 = ["value", "disabled"];
const _hoisted_20 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          Please be sure to provide the correct email address as further\n          communications, including letters, will be issued to this email\n          account If an incorrect email address is provided, there could be a\n          resulting Data Protection breach therefore it is essential that the\n          correct information is provided\n        ", -1));
const _hoisted_22 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Would you like to add a secondary contact to this form? *\n            ", -1));
const _hoisted_24 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_25 = { class: "mt-4 space-y-4" };
const _hoisted_26 = { class: "flex items-start" };
const _hoisted_27 = { class: "h-5 flex items-center" };
const _hoisted_28 = ["disabled", "checked"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "secondaryContact",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_30 = { class: "flex items-start" };
const _hoisted_31 = { class: "h-5 flex items-center" };
const _hoisted_32 = ["disabled", "checked"];
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "secondaryContact",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_34 = {
    key: 0,
    class: "grid grid-cols-3 gap-6"
};
const _hoisted_35 = {
    key: 0,
    class: "col-span-6 mb-4"
};
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Secondary contact details *", -1));
const _hoisted_37 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_38 = {
    key: 1,
    class: "col-span-6 p-4 border border-gray-300 rounded-md"
};
const _hoisted_39 = {
    key: 0,
    class: "flex w-full justify-end"
};
const _hoisted_40 = { class: "col-span-6" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryName",
    class: "block text-sm font-medium text-gray-700"
}, "Secondary contact name: *", -1));
const _hoisted_42 = ["value"];
const _hoisted_43 = { class: "col-span-6 mt-4" };
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryEmail",
    class: "block text-sm font-medium text-gray-700"
}, "Secondary contact email address: *", -1));
const _hoisted_45 = ["value"];
const _hoisted_46 = { class: "col-span-6 mt-4" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "secondaryPhone",
    class: "block text-sm font-medium text-gray-700"
}, "Secondary contact telephone number: *", -1));
const _hoisted_48 = ["value", "disabled"];
const _hoisted_49 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "\n          This person will have access to the online employee amendment form and\n          will receive update emails. The secondary contact will not receive any\n          letters, contract and/or terms and conditions for the employee as\n          these will be issued to the primary contact only.\n        ", -1));
const _hoisted_51 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_52 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_search = _resolveComponent("user-search");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    (!_ctx.formData?.name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(),
                            _createVNode(_component_user_search, {
                                group: "HM",
                                onUpdatedUser: _cache[0] || (_cache[0] = ($event) => (_ctx.handleUser($event)))
                            }),
                            _createTextVNode(),
                            (_ctx.v$.formData.name.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n              * " + _toDisplayString(_ctx.v$.formData.name.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (!_ctx.disableForm)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("button", {
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.selectAnotherUser && _ctx.selectAnotherUser(...args)), ["prevent"]))
                                    }, [
                                        _createVNode(_component_XIcon, { class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer" })
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "name-input",
                                    value: _ctx.formData.name,
                                    type: "text",
                                    name: "name",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                            'error-border': _ctx.v$.formData.name.$error,
                                            'border-red-500': _ctx.v$.formData.name.$error,
                                        }]),
                                    disabled: "",
                                    onInput: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.name.$touch()))
                                }, null, 42, _hoisted_13)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "email-input",
                                    value: _ctx.formData.email,
                                    type: "email",
                                    name: "email",
                                    autocomplete: "email",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                            'error-border': _ctx.v$.formData.email.$error,
                                            'border-red-500': _ctx.v$.formData.email.$error,
                                        }]),
                                    disabled: "",
                                    onInput: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.email.$touch()))
                                }, null, 42, _hoisted_16)
                            ])
                        ]))
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(),
                    _createElementVNode("input", {
                        id: "phone-input",
                        value: _ctx.formData.phone,
                        disabled: _ctx.disableForm,
                        type: "text",
                        name: "phone",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                'error-border': _ctx.v$.formData.phone.$error,
                                'border-red-500': _ctx.v$.formData.phone.$error,
                            }]),
                        onInput: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.phone.$touch()))
                    }, null, 42, _hoisted_19),
                    _createTextVNode(),
                    (_ctx.v$.formData.phone.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "\n            * " + _toDisplayString(_ctx.v$.formData.phone.$errors[0].$message), 1))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _hoisted_21,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("fieldset", null, [
                        _hoisted_23,
                        _createTextVNode(),
                        (_ctx.v$.formData.secondaryContact.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "\n              * " + _toDisplayString(_ctx.v$.formData.secondaryContact.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("input", {
                                            id: "radio-secondary-contact-yes",
                                            value: "Yes",
                                            name: "secondaryContact",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData.secondaryContact === 'Yes',
                                            onChange: _cache[8] || (_cache[8] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.secondaryContact.$touch()))
                                        }, null, 40, _hoisted_28)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_29
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("input", {
                                            id: "radio-secondary-contact-no",
                                            value: "No",
                                            name: "secondaryContact",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData.secondaryContact === 'No',
                                            onChange: _cache[10] || (_cache[10] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.secondaryContact.$touch()))
                                        }, null, 40, _hoisted_32)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_33
                                ])
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                (_ctx.formData.secondaryContact === 'Yes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (!_ctx.formData.secondaryName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _hoisted_36,
                                _createTextVNode(),
                                _createVNode(_component_user_search, {
                                    group: "HM",
                                    onUpdatedUser: _cache[12] || (_cache[12] = ($event) => (_ctx.handleSecondaryUser($event)))
                                }),
                                _createTextVNode(),
                                (_ctx.v$.formData.secondaryName.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "\n              * " + _toDisplayString(_ctx.v$.formData.secondaryName.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (!_ctx.disableForm)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _createElementVNode("button", {
                                            onClick: _cache[13] || (_cache[13] = _withModifiers(
                                            //@ts-ignore
                                            (...args) => (_ctx.selectAnotherSecondaryUser && _ctx.selectAnotherSecondaryUser(...args)), ["prevent"]))
                                        }, [
                                            _createVNode(_component_XIcon, { class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer" })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_40, [
                                    _hoisted_41,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "secondary-name-input",
                                        value: _ctx.formData.secondaryName,
                                        type: "text",
                                        name: "secondaryName",
                                        autocomplete: "name",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        disabled: "",
                                        onInput: _cache[14] || (_cache[14] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, null, 40, _hoisted_42)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_43, [
                                    _hoisted_44,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "secondary-email-input",
                                        value: _ctx.formData.secondaryEmail,
                                        type: "email",
                                        name: "secondaryEmail",
                                        autocomplete: "email",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                        disabled: "",
                                        onInput: _cache[15] || (_cache[15] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, null, 40, _hoisted_45)
                                ])
                            ])),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "secondary-hiring-manager-phone-input",
                                value: _ctx.formData.secondaryPhone,
                                disabled: _ctx.disableForm,
                                type: "text",
                                name: "secondaryPhone",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", {
                                        'error-border': _ctx.v$.formData.secondaryPhone.$error,
                                        'border-red-500': _ctx.v$.formData.secondaryPhone.$error,
                                    }]),
                                onInput: _cache[16] || (_cache[16] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.secondaryPhone.$touch()))
                            }, null, 42, _hoisted_48),
                            _createTextVNode(),
                            (_ctx.v$.formData.secondaryPhone.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, "\n              * " + _toDisplayString(_ctx.v$.formData.secondaryPhone.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _hoisted_50
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[18] || (_cache[18] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSaveForm && _ctx.handleSaveForm(...args)), ["prevent"]))
                    }, "\n          Next\n        ", 8, _hoisted_52)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
